import {GetObjectCommand, ListObjectsV2Command, PutObjectCommand, S3Client, S3ClientConfig} from "@aws-sdk/client-s3";
import {
    blobToBase64,
    blobToFile,
    convertImageToWebp, createCopyLinkByLibraryItem,
    createNoteElementByNote, decodeDeeplink,
    extFromMineType,
    getFileName,
    getFileNameExt,
    getFileNameWithoutExt,
    isAudioFileElement, isDeepLink, isLiveVideoType,
    isPdfFileElement, isString,
    isStringNullOrEmpty,
    isVideo, isVideoAnnoElement,
    recursionMindmapData
} from "@/utils";
import {message} from "antd";
import {
    constBase64ToFileBlob,
    convertBase64ToBlob,
    dataURLToFile
} from "../../@excalidraw/packages/excalidraw/data/blob";
import {ABCDEFG, EVENT_UPDATE_NOTE, EVENT_UPDATE_PROGRESS, FDLJKSJFLS, HAFAHA, KEY_FILE_DIR} from "@/Const";
import {postMessage} from "@/common/event";
import {
    isEmbedableBookmarkElement,
    isEmbeddableElement,
    isMindmapElement, isProjectLinkElement, isStickyNotesElement, isTextElement
} from "../../@excalidraw/packages/excalidraw/element/typeChecks";
import {ipcInvoke} from "@/common/ipc";
import {getCardById, getCardDoc, getCardListByLibraryId, updateCard} from "@model/card";
import {loop, loopAllNode, loopAllNodeAsync} from "@/TreeUtils";
import {dbGetHighlightByLibraryId} from "@model/highlight";
import {getCardlinkCacheById, updatecardlinkCache} from "@model/cardLinkCache";
import CryptoJS from 'crypto-js';
import {MIME_TYPES} from "../../@excalidraw/packages/utils";
import {imgServer} from "@/components/EditorV2/imgServer";
import {isZh} from "@/language";
import OSS from 'ali-oss';
import {jsonToBlob} from "@/api/AliOss";
import {APP_WEB} from "@/electron_interactive";

export const AWS_S3_PRE_DATA_URL = "https://muenzo-data.s3.amazonaws.com/public/";
export const ALIOSS_PRE_DATA_URL = "https://muenzo-data.oss-cn-beijing.aliyuncs.com/public/";

export const getShareDataUrl = ()=>{
    if (isAliOss()){
        return ALIOSS_PRE_DATA_URL;
    }
    return AWS_S3_PRE_DATA_URL;
}
const REGION = "us-east-1";

export const getShareFileUrl = (szProjId:any,szFileName:any)=>{
    return getShareDataUrl() + ''+szProjId+'/notesfile/'+ (szFileName)
}

export const isAliOss = ()=>{
    console.log('widnow.location.href=*****'+window.location.href+'*******');
    if (APP_WEB){
        return window.location.href.includes('/cn/');
    }
    return isZh();
}

export function getClient(){
    var abcdef='AK';
    var abc = "IAZQBRZOP";
    var aaabbb = "5D";
    const client = new S3Client({
        region:REGION,
        credentials:{
            accessKeyId: abcdef+abc +'7HUKTCM'+aaabbb,
            secretAccessKey:ABCDEFG+'/'+'hZ+9N5h8OJ9'+FDLJKSJFLS+'Id35ka0tL'+HAFAHA
        },
    });
    return client;
}

export function getAliOssClient(){
    let a = 'fldsjfsFflsjfs';
    a = a.substring(14) + 'LTAI5tEuKSvdwM';
    let b = 'UHGNneOJiIncKvVp3M';
    const client = new OSS({
        // 从环境变量中获取访问凭证。运行本代码示例之前，请确保已设置环境变量OSS_ACCESS_KEY_ID和OSS_ACCESS_KEY_SECRET。
        accessKeyId: a+'kJXebP5iDn',
        accessKeySecret: b+'uSYBdbwUOBZE',
        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
        region: 'oss-cn-beijing',
        // 使用V4签名算法
        authorizationV4: true,
        // yourBucketName填写Bucket名称。
        bucket: 'muenzo-data',
        // yourEndpoint填写Bucket所在地域对应的公网Endpoint。以华东1（杭州）为例，Endpoint填写为https://oss-cn-hangzhou.aliyuncs.com。
        endpoint: 'https://oss-cn-beijing.aliyuncs.com',
    });
    return client;
}

const hasUpdate = (originJsonData:any,data:any,isCanvas:any)=>{
    if (isCanvas && originJsonData.hasOwnProperty('canvas')){
        let bHasUpdate = true;
        loop(originJsonData.canvas,data.key,(item, i, data, parent)=>{
            bHasUpdate =  item.title !== data.title ||
                JSON.stringify(item.drawJson) !== JSON.stringify(data.drawJson) ||
                JSON.stringify(item.subNotes) != JSON.stringify(data.subNotes);
        })
        return bHasUpdate;

        /*
        for (let i=0;i<originJsonData.canvas.length;i++){
            const item = originJsonData.canvas[i];
            if (item.isFolder){
                if (item.key === data.key){
                    return (item.title !== data.title);
                }

                for (let j=0;j<item.children.length;j++){
                    const subItem = item.children[j];
                    if (subItem.key === data.key){
                        return  subItem.title !== data.title ||
                            JSON.stringify(subItem.drawJson) !== JSON.stringify(data.drawJson) ||
                            JSON.stringify(subItem.subNotes) != JSON.stringify(data.subNotes);
                    }
                }
            }else{
                if (item.key === data.key){
                    return  item.title !== data.title ||
                        JSON.stringify(item.drawJson) !== JSON.stringify(data.drawJson) ||
                        JSON.stringify(item.subNotes) != JSON.stringify(data.subNotes);
                }
            }
        }*/

    }else if (originJsonData.hasOwnProperty('notes')){
        for (let i=0;i<originJsonData.notes.length;i++){
            const item = originJsonData.notes[i];
            if (item.isFolder){
                if (item.key === data.key){
                    return (item.title !== data.title);
                }

                for (let j=0;j<item.children.length;j++){
                    const subItem = item.children[j];
                    if (subItem.key === data.key){
                        return  subItem.title != data.title || JSON.stringify(subItem) !== JSON.stringify(data)
                    }
                }
            }else{
                if (item.key === data.key){
                    return  item.title != data.title || JSON.stringify(item) !== JSON.stringify(data)
                }
            }
        }
    }

    return true;//找不到的表示有更新....
}

export async function uploadS3(szProjId:any,szJsonData:any,szOriginJson:any){
    const jsonData = JSON.parse(szJsonData);
    let originJsonData = {};
    if (!isStringNullOrEmpty(szOriginJson)){
        originJsonData = JSON.parse(szOriginJson);
    }

    const dtNow = Date.now();
    const client = getClient();

    let arrayPutCommands = [];
    //first part  page.
    let isUpdate = false;
    for (let i=0;i<jsonData.canvas.length;i++){
        const item = jsonData.canvas[i];
        isUpdate = false;
        if (item.hasUpdate || hasUpdate(originJsonData,item,true)){
            item.updateTime = dtNow;
            isUpdate = true;
        }

        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                const subItem = item.children[j];
                if (subItem.hasUpdate || hasUpdate(originJsonData,subItem,true)){
                    const command = new PutObjectCommand({
                        Bucket:'muenzo-data',
                        Key:'public/'+szProjId+'/canvas/'+item.key+'/'+subItem.key,
                        Body:JSON.stringify(subItem)
                    })
                    arrayPutCommands.push(command);

                    subItem.updateTime = dtNow;
                    subItem.hasUpdate = false;
                }

                //清空数据量大的2个对象
                subItem.drawJson = {};
                subItem.subNotes = [];
            }
        }else{
            if(item.hasUpdate || isUpdate){
                const command = new PutObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/canvas/'+item.key,
                    Body:JSON.stringify(item)
                })
                arrayPutCommands.push(command);

                item.hasUpdate = false;
            }

            //清空数据量大的2个对象
            item.drawJson = {};
            item.subNotes = [];
        }
    }
    //second part notes.
    for (let i=0;i<jsonData.notes.length;i++){
        const item = jsonData.notes[i];
        isUpdate = false;
        if (hasUpdate(originJsonData,item,false)){
            item.updateTime = dtNow;
            isUpdate = true;
        }

        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                const subItem = item.children[j];
                if (subItem.hasUpdate || hasUpdate(originJsonData,subItem,false)) {
                    const command = new PutObjectCommand({
                        Bucket:'muenzo-data',
                        Key:'public/'+szProjId+'/notes/'+item.key+'/'+subItem.key,
                        Body:JSON.stringify(subItem)
                    })
                    arrayPutCommands.push(command);
                    subItem.updateTime = dtNow;
                    subItem.hasUpdate = false;
                }

                item.noteDataDoc = '';
            }
        }else{
            if (item.hasUpdate || isUpdate){
                const command = new PutObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/notes/'+item.key,
                    Body:JSON.stringify(item)
                })
                arrayPutCommands.push(command);
                item.hasUpdate = false;
            }

            item.noteDataDoc = '';
        }
    }

    const command = new PutObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId+'/'+szProjId,
        Body:JSON.stringify(jsonData)
    })
    arrayPutCommands.push(command);

    console.log('***upload*****');
    console.log(arrayPutCommands);

    await Promise.all(arrayPutCommands.map((command) => client.send(command))).then(() => {
        console.log('all files uploaded success')
    }).catch((error) => {
        console.error('error uploading files:' + error);
    });

    /*单个文件上传。。。。。不用
    const command = new PutObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId,
        Body:szJsonData
    })

    try {
        const response = await client.send(command);
        console.log(response);
    }catch (err){
        console.log(err);
    }*/
}

/**
 * 比较本地存的时间与服务器上的canvas item的时间
 * @param originJsonData
 * @param data
 * @param isCanvas
 */
const hasRemoteUpdate = (originJsonData:any,data:any,isCanvas:any)=>{
    if (isCanvas && originJsonData.hasOwnProperty('canvas')){
        let bHasUpdate = true;

        loop(originJsonData.canvas,data.key,(node, i, data, parent)=>{
            bHasUpdate = (node.updateTime != data.updateTime);
        })
        return bHasUpdate;

        // for (let i=0;i<originJsonData.canvas.length;i++){
        //     const item = originJsonData.canvas[i];
        //     if (item.isFolder){
        //         for (let j=0;j<item.children.length;j++){
        //             const subItem = item.children[j];
        //             if (subItem.key === data.key){
        //                 return subItem.updateTime != data.updateTime;
        //             }
        //         }
        //     }else{
        //         if (item.key === data.key){
        //             return item.updateTime != data.updateTime;
        //         }
        //     }
        // }
    }else if  (originJsonData.hasOwnProperty('notes')){
        for (let i=0;i<originJsonData.notes.length;i++){
            const item = originJsonData.notes[i];
            if (item.isFolder){
                for (let j=0;j<item.children.length;j++){
                    const subItem = item.children[j];
                    if (subItem.key === data.key){
                        return subItem.updateTime != data.updateTime;
                    }
                }
            }else{
                if (item.key === data.key){
                    return item.updateTime != data.updateTime;
                }
            }
        }
    }
    return true;
}

const setItemToJson = (jsonData:any,data:any,isCanvas:any)=>{
    let bFind = false;
    if (isCanvas){
        loop(jsonData.canvas,data.key,(node, i, data, parent)=>{
            node = data;//----------
        })

        // for (let i=0;i<jsonData.canvas.length;i++){
        //     const item = jsonData.canvas[i];
        //     bFind = false;
        //     if (item.isFolder){
        //         for (let j=0;j<item.children.length;j++){
        //             const subItem = item.children[j];
        //             if (subItem.key === data.key){
        //                 item.children[j] = data;
        //                 bFind = true;
        //                 break;
        //             }
        //         }
        //         if (bFind){
        //             break;
        //         }
        //     }else{
        //         if (item.key === data.key){
        //             jsonData.canvas[i] = data;
        //             break;
        //         }
        //     }
        // }
    }else{
        for (let i=0;i<jsonData.notes.length;i++){
            const item = jsonData.notes[i];
            bFind = false;
            if (item.isFolder){
                for (let j=0;j<item.children.length;j++){
                    const subItem = item.children[j];
                    if (subItem.key === data.key){
                        item.children[j] = data;
                        bFind = true;
                        break;
                    }
                }
                if (bFind){
                    break;
                }
            }else{
                if (item.key === data.key){
                    jsonData.notes[i] = data;
                    break;
                }
            }
        }
    }
}

const getItemByKey = (originJsonData:any,szKey:any,isCanvas:any)=>{
    if (isCanvas && originJsonData.hasOwnProperty('canvas')){
        let item = {};
        loop(originJsonData.canvas,szKey,(node, i, data, parent)=>{
            item = node;
        })
        return item;

        // for (let i=0;i<originJsonData.canvas.length;i++){
        //     const item = originJsonData.canvas[i];
        //     if (item.isFolder){
        //         for (let j=0;j<item.children.length;j++){
        //             const subItem = item.children[j];
        //             if (subItem.key === szKey){
        //                 return subItem;
        //             }
        //         }
        //     }else{
        //         if (item.key === szKey){
        //             return item;
        //         }
        //     }
        // }
    }else if  (originJsonData.hasOwnProperty('notes')){
        for (let i=0;i<originJsonData.notes.length;i++){
            const item = originJsonData.notes[i];
            if (item.isFolder){
                for (let j=0;j<item.children.length;j++){
                    const subItem = item.children[j];
                    if (subItem.key === szKey){
                        return subItem;
                    }
                }
            }else{
                if (item.key === szKey){
                    return item;
                }
            }
        }
    }
    return {};
}


export async function getS3Data(szProjId:string,originJsonData:any){
    const client = getClient();
    let arrayGetCommand:any = [];
    //1.获取主目录
    const command = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId+'/'+szProjId,
    })
    const { Body } = await client.send(command);
    const objStr = await Body.transformToString();
    //2.获取有更新的数据
    const jsonData = JSON.parse(objStr);
    for (let i=0;i<jsonData.canvas.length;i++){
        const item = jsonData.canvas[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                const subItem = item.children[j];
                if (hasRemoteUpdate(originJsonData,subItem,true)){
                    const cmd = new GetObjectCommand({
                        Bucket:'muenzo-data',
                        Key:'public/'+szProjId+'/canvas/'+item.key+'/'+subItem.key,
                    })
                    arrayGetCommand.push(cmd);
                }else{
                    item.children[j] = getItemByKey(originJsonData,subItem.key,true);
                }
            }
        }else{
            if (hasRemoteUpdate(originJsonData,item,true)){
                const cmd = new GetObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/canvas/'+item.key,
                })
                arrayGetCommand.push(cmd);
            }else{
                jsonData.canvas[i] = getItemByKey(originJsonData,item.key,true);
            }
        }
    }
    //note
    for (let i=0;i<jsonData.notes.length;i++){
        const item = jsonData.notes[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                const subItem = item.children[j];
                if (hasRemoteUpdate(originJsonData,subItem,false)){
                    const cmd = new GetObjectCommand({
                        Bucket:'muenzo-data',
                        Key:'public/'+szProjId+'/notes/'+item.key+'/'+subItem.key,
                    })
                    arrayGetCommand.push(cmd);
                }else{
                    item.children[j] = getItemByKey(originJsonData,subItem.key,false);
                }
            }
        }else{
            if (hasRemoteUpdate(originJsonData,item,false)){
                const cmd = new GetObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/notes/'+item.key,
                })
                arrayGetCommand.push(cmd);
            }else{
                jsonData.notes[i] = getItemByKey(originJsonData,item.key,false);
            }
        }
    }

    console.log('***request*****');
    console.log(arrayGetCommand);

    return new Promise((resolve, reject) => {
        Promise.all(arrayGetCommand.map((command:any)=>client.send(command)))
            .then(async (res)=>{
            for (let i=0;i<res.length;i++){
                const szStr = await res[i].Body.transformToString();
                const obj = JSON.parse(szStr);
                //根据ID插入到相应的位置
                setItemToJson(jsonData,obj,!obj.hasOwnProperty('noteDataDoc'));
            }
            resolve(jsonData);
        }).catch(error=>{
            console.log('get data promise error:'+error);
            reject();
        });
    })



    // try {
    //     const { Body } = await client.send(command);
    //     const objStr = Body.transformToString();
    //     console.log(objStr);
    //     return objStr;
    // }catch (err){
    //     console.log(err);
    // }
}


/*************new split图片*************/

/**
 * 单独下载一个文件...
 * @param szProjId
 * @param szFolderKey
 * @param pageKey
 * @param szFileId
 */
export const downloadFileDataURL = (szProjId:string,szFolderKey:string,pageKey:string,szFileId:string)=>{
    const client = getClient();

    const command = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId+'/canvas/'+szFolderKey+pageKey+"/"+szFileId,
    })
    return client.send(command);
}

const setFileDataURLOrCommand = (szProjId:string,szFolderKey:string,remoteItem:any,localDataItem:any,arrayGetFileCommand:any,isLazyLoading=true)=>{
    for (var key in remoteItem.drawJson.files){
        if (!remoteItem.drawJson.files.hasOwnProperty(key))continue;

        var remoteFile = remoteItem.drawJson.files[key];
        const localFile = localDataItem?.drawJson?.files[remoteFile.id];
        if (localFile != undefined && localFile.dataURL){
            remoteFile.dataURL = localFile.dataURL;
        }else{
            if (!isLazyLoading){
                //command
                const cmd = new GetObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/canvas/'+szFolderKey+remoteItem.key+"/"+remoteFile.id,
                })
                arrayGetFileCommand.push(cmd);
            }
        }
    }
}


/**
 * 分离图片上传...
 * @param szProjId
 * @param szJsonData
 * @param szOriginJson
 */
export async function uploadS3New(szProjId:any,szJsonData:any,szOriginJson:any,arrayNotesImage:any,arrayFiles:any){
    const jsonData = JSON.parse(szJsonData);
    let originJsonData = {};
    if (!isStringNullOrEmpty(szOriginJson)){
        originJsonData = JSON.parse(szOriginJson);
    }


    const dtNow = Date.now();
    let client:any;
    if(isAliOss()){
        client = getAliOssClient();
    }else{
       client = getClient();
    }

    //first get remote project....
    //1.获取笔记的数据集合目录
    const szPublicNotesImageKey = 'public/'+szProjId+"/notes-image";
    const commandFirst = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:szPublicNotesImageKey,
    })

    let arrayPutCommands = [];
    let jsonRemoteNotesImage = null;
    if (arrayNotesImage && arrayNotesImage.length > 0){
        try{
            let objStr = '';
            if (isAliOss()){
                const result = await client.get(szPublicNotesImageKey);
                // result.content 是 Buffer（在浏览器中是 ArrayBuffer 或 Uint8Array）
                // 需要转成字符串再解析 JSON
                const decoder = new TextDecoder('utf-8');
                objStr = decoder.decode(result.content);
            }else{
                const { Body } = await client.send(commandFirst);
                // @ts-ignore
                objStr = await Body.transformToString();
            }

            //2.获取有更新的数据
            jsonRemoteNotesImage = JSON.parse(objStr);
        }catch (err){
            console.log(err);
        }

        for (let i=0;i<arrayNotesImage.length;i++){
            const item = arrayNotesImage[i];
            let isExist = false;
            if (jsonRemoteNotesImage != null){
                for (let iRemote = 0;iRemote<jsonRemoteNotesImage.length;iRemote++){
                    if (jsonRemoteNotesImage[iRemote].id == item.id){
                        isExist = true;
                        break;
                    }
                }
            }
            if (!isExist){
                if (!item.data){
                    const szFileName = localStorage.getItem(KEY_FILE_DIR) + item.id + '.'+item.ext;
                    item.data = await ipcInvoke('read-file-base64', {filePath:szFileName})
                }
                //添加到command
                let body = dataURLToFile('data:image/'+ item.ext +';base64,'+item.data,item.id+'.'+item.ext);
                try{
                    const blob = await convertImageToWebp('data:image/'+ item.ext +';base64,'+item.data);
                    body = blobToFile(blob);
                }catch (e){
                    console.log('convertImageToWebp...fail')
                }

                const command = new PutObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/notesimage/'+item.id+"."+item.ext,//path-- public/projId/canvas/文件夹id/文件id
                    Body:body
                })
                arrayPutCommands.push(command);

            }
        }
    }

    //,上传图片集合--只有ID
    //clear data.....
    for (let i=0;i<arrayNotesImage.length;i++){
        arrayNotesImage[i].data = "";
    }
    const commandNoteImage = new PutObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId+"/notes-image",
        Body:JSON.stringify(arrayNotesImage)
    })
    arrayPutCommands.push(commandNoteImage);

    //只是图片的缩略图...


    //second get remote project....
    //2.获取文件的数据集合目录
    const commandFile = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId+"/notes-file",
    })

    let jsonRemoteFile = null;
    if (arrayFiles && arrayFiles.length > 0){
        if (isAliOss()){
            try{
                const result = await client.get(commandFile.input.Key);
                // result.content 是 Buffer（在浏览器中是 ArrayBuffer 或 Uint8Array）
                // 需要转成字符串再解析 JSON
                const decoder = new TextDecoder('utf-8');
                const objStr = decoder.decode(result.content);
                jsonRemoteFile = JSON.parse(objStr);
            }catch (e){

            }
        }else{
            try{
                const { Body } = await client.send(commandFile);
                // @ts-ignore
                const objStr = await Body.transformToString();
                //2.获取有更新的数据
                jsonRemoteFile = JSON.parse(objStr);
            }catch (err){
                console.log(err);
            }
        }


        for (let i=0;i<arrayFiles.length;i++){
            const item = arrayFiles[i];
            let isExist = false;
            if (jsonRemoteFile != null){
                for (let iRemote = 0;iRemote<jsonRemoteFile.length;iRemote++){
                    if (jsonRemoteFile[iRemote].id == item.id && jsonRemoteFile[iRemote].ext == item.ext){
                        isExist = true;
                        break;
                    }
                }
            }
            if (!isExist){
                const buffer = await constBase64ToFileBlob(item.data,item.fileName);
                //添加到command
                const command = new PutObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/notesfile/'+item.fileName,//path-- public/projId/canvas/文件夹id/文件id
                    Body:buffer
                })
                arrayPutCommands.push(command);
            }
        }
    }
    //上传文件集合
    for (let i=0;i<arrayFiles.length;i++){
        arrayFiles[i].data = "";
    }
    const commandFileData = new PutObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId+"/notes-file",
        Body:JSON.stringify(arrayFiles)
    })
    arrayPutCommands.push(commandFileData);


    //first part  page.
    let isUpdate = false;

    //额外的库中的信息，标注等各种...
    const arrayLibrarys:any = [];
    const arrayWeblinkCache:any = [];

    await loopAllNodeAsync(jsonData.canvas,async (item)=>{
        if (item.drawJson?.elements){
            isUpdate = false;
            if (item.hasUpdate || hasUpdate(originJsonData,item,true)){
                item.updateTime = dtNow;
                isUpdate = true;
            }

            if(item.hasUpdate || isUpdate){
                if ('elements' in item.drawJson){
                    for(let nEle=0;nEle < item.drawJson.elements.length;nEle++){
                        const ele = item.drawJson.elements[nEle];
                        if (isDeepLink(ele.link)){
                            const deeplink = decodeDeeplink(ele.link);
                            if (deeplink.type == 'library'){
                                const library = await getCardById(deeplink.id);
                                if (library){
                                    arrayLibrarys.push(library);
                                }
                            }
                        }
                        //这里带个额外的信息。。。
                        if (isEmbeddableElement(ele) || isPdfFileElement(ele) || isAudioFileElement(ele) || isAudioFileElement(ele)){
                            const library = await getCardById(ele.customData?.generationData?.id);
                            if (library){
                                arrayLibrarys.push(library);
                                //加入所有的注记.
                                const arrayAnnos = await getCardListByLibraryId(library.id);
                                if (arrayAnnos){
                                    arrayLibrarys.push(...arrayAnnos);
                                }
                            }

                            if (isEmbedableBookmarkElement(ele)){
                                //书签的，需要带上cache
                                const md5 = CryptoJS.MD5(ele.link).toString();
                                const cache = await getCardlinkCacheById(md5);
                                if (cache){
                                    arrayWeblinkCache.push(cache)
                                }
                            }
                        }

                        if (ele.fileId){
                            const file = item.drawJson.files[ele.fileId];
                            if (ele.hasUpdate){
                                let body = JSON.stringify(file);
                                //convert to webp...base64
                                let jsonNew = JSON.parse(body);
                                const szLocalFilePath = localStorage.getItem(KEY_FILE_DIR) + file.id + '.'+extFromMineType(file.mimeType);
                                jsonNew.dataURL = await ipcInvoke('read-file-base64',{filePath:szLocalFilePath})
                                if (jsonNew.dataURL){
                                    jsonNew.type = file.mimeType;
                                    jsonNew.dataURL = `data:${file.mimeType};base64,`+jsonNew.dataURL;
                                    if (file.mimeType != MIME_TYPES.gif && file.mimeType != MIME_TYPES.svg){
                                        const blobWebp = await convertImageToWebp(jsonNew.dataURL);
                                        jsonNew.dataURL = await blobToBase64(blobWebp);
                                        jsonNew.type = 'image/webp';
                                    }

                                    body = JSON.stringify(jsonNew);
                                    //convert end....
                                    //需要上传
                                    const command = new PutObjectCommand({
                                        Bucket:'muenzo-data',
                                        Key:'public/'+szProjId+'/canvas/'+item.key+'/'+file.id,//path-- public/projId/canvas/文件夹id/文件id
                                        Body:body
                                    })
                                    arrayPutCommands.push(command);
                                }
                            }
                        }else if (isProjectLinkElement(ele)){//额外的图片上传到notesfile下面去......
                            if (ele.customData?.thumbImage){
                                const szFileName = getFileName(ele.customData?.thumbImage);
                                const szLocalFilePath = localStorage.getItem(KEY_FILE_DIR) + szFileName;
                                const szBase64 = await ipcInvoke('read-file-base64',{filePath:szLocalFilePath})
                                let body = dataURLToFile('data:image/'+ getFileNameExt(szFileName) +';base64,'+szBase64,szFileName);
                                // const blob = await convertImageToWebp('data:image/'+ item.ext +';base64,'+item.data);
                                // body = blobToFile(blob);

                                const command = new PutObjectCommand({
                                    Bucket:'muenzo-data',
                                    Key:'public/'+szProjId+'/notesfile/'+szFileName,//path-- public/projId/canvas/文件夹id/文件id
                                    Body:body
                                })
                                arrayPutCommands.push(command);
                            }
                        }
                        else if (isMindmapElement(ele)) {
                            await recursionMindmapData(ele.data, async (data: any) => {
                                let szDeeplink = '';
                                if (data.extra) {
                                    if (data.extra.type == 'card') {
                                        const card = await getCardById(data.extra.id);
                                        if (card) {
                                            arrayLibrarys.push(card);
                                        }
                                    }else if (data.extra.type == 'pdf'){
                                        //放到下面去处理....
                                        szDeeplink = createCopyLinkByLibraryItem(data.extra,false);
                                    }
                                }

                                if (data.attachmentUrl || data.hyperlink){
                                    if (isString(data.attachmentUrl)){
                                        if (isDeepLink(data.attachmentUrl)){
                                            szDeeplink = data.attachmentUrl;
                                        }
                                    }else if (data.attachmentUrl?.url){
                                        szDeeplink = data.attachmentUrl.url;
                                    }
                                    if (data.hyperlink){
                                        szDeeplink = data.hyperlink;
                                    }
                                }

                                if (szDeeplink){
                                    const deeplink = decodeDeeplink(szDeeplink);
                                    if (deeplink.type == 'library'){
                                        //只处理library中的数据.
                                        const card = await getCardById(deeplink.id);
                                        if (card){
                                            if (!arrayLibrarys.some(p=>p.id == card.id)){
                                                arrayLibrarys.push(card);

                                                const szLibraryId = card.id;

                                                if (card.type == 'pdf'){
                                                    //装注记文件.
                                                    const pdfAnnos = await ipcInvoke('get-annotations',{fileId:card.id});
                                                    if (pdfAnnos){
                                                        // arrayPdfFileHighlights.push({id:card.id,annotations:pdfAnnos});
                                                    }
                                                }else if (card.type == 'video'){
                                                    const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                                    if (highlight){
                                                        // arrayVideoHighlights.push(highlight)
                                                    }
                                                }else if (card.type == 'audio'){
                                                    const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                                    if (highlight){
                                                        // arrayAudioHighlights.push(highlight)
                                                    }
                                                }else if (card.type == 'card'){
                                                    const arrayCardHighs = await getCardListByLibraryId(szLibraryId);
                                                    for (let k=0;k<arrayCardHighs.length;k++){
                                                        const item = arrayCardHighs[k];
                                                        // if (!arrayCardHighlights.some(p=>p.id == item.id)){
                                                        //     arrayCardHighlights.push(item);
                                                        // }
                                                    }
                                                }else if (isLiveVideoType(card.type)){
                                                    //在线视频类的...
                                                    const highlight = await dbGetHighlightByLibraryId(szLibraryId);
                                                    if (highlight){
                                                        // arrayVideoHighlights.push(highlight)
                                                    }
                                                }

                                            }
                                        }
                                    }
                                }
                            })
                        }
                        //mindmap....--当成file来处理
                        // if (isMindmapElement(ele)){
                        //     await recursionMindmapData(ele.data,async (data:any)=>{
                        //         console.log(data);
                        //         if (data.image){
                        //             const szId = getFileNameWithoutExt(data.image);
                        //             let szBase64Img = await ipcInvoke('get-img-by-id',szId)
                        //             const buffer = await constBase64ToFileBlob(szBase64Img,getFileNameExt(data.image));
                        //             //convert end....
                        //             //需要上传
                        //             const command = new PutObjectCommand({
                        //                 Bucket:'muenzo-data',
                        //                 Key:'public/'+szProjId+'/canvas/'+item.key+'/'+szId,//path-- public/projId/canvas/文件夹id/文件id
                        //                 Body:buffer
                        //             })
                        //             arrayPutCommands.push(command);
                        //         }
                        //
                        //     })
                        // }
                    }
                }

                for (var key in item.drawJson.files){
                    if (item.drawJson.files.hasOwnProperty(key)){
                        let file = item.drawJson.files[key];
                        file.dataURL = '';
                    }
                }

                const command = new PutObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/canvas/'+item.key,
                    Body:JSON.stringify(item)
                })
                arrayPutCommands.push(command);

                item.hasUpdate = false;
            }
        }
    })


    //second part notes.
    for (let i=0;i<jsonData.notes.length;i++){
        const item = jsonData.notes[i];
        isUpdate = false;
        if (hasUpdate(originJsonData,item,false)){
            item.updateTime = dtNow;
            isUpdate = true;
        }

        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                const subItem = item.children[j];
                if (subItem.hasUpdate || hasUpdate(originJsonData,subItem,false)) {
                    const command = new PutObjectCommand({
                        Bucket:'muenzo-data',
                        Key:'public/'+szProjId+'/notes/'+item.key+'/'+subItem.key,
                        Body:JSON.stringify(subItem)
                    })
                    arrayPutCommands.push(command);
                    subItem.updateTime = dtNow;
                    subItem.hasUpdate = false;
                }

                item.noteDataDoc = '';
            }
        }else{
            if (item.hasUpdate || isUpdate){
                if (!item.noteDataDoc){
                    item.noteDataDoc = await getCardDoc(item.key);
                }
                const command = new PutObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/notes/'+item.key,
                    Body:JSON.stringify(item)
                })
                arrayPutCommands.push(command);
                item.hasUpdate = false;
            }

            item.noteDataDoc = '';
        }
    }

    //加入库.
    jsonData.arrayLibrarys = arrayLibrarys;

    //加入weblink的缓存...
    jsonData.arrayWeblinkCache = arrayWeblinkCache;

    const command = new PutObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szProjId+'/'+szProjId,
        Body:JSON.stringify(jsonData)
    })
    arrayPutCommands.push(command);

    // console.log('***upload*****');
    // console.log(arrayPutCommands);

    if (isAliOss()){
        await Promise.all(arrayPutCommands.map((command) => client.put(command.input.Key,getAliOssObjectFromAws3(command)).catch((err)=>{
            return null;
        }))).then((res) => {

            console.log('all files uploaded success')
        }).catch((error) => {
            console.error('error uploading files:' + error);
        });
    }else{
        await Promise.all(arrayPutCommands.map((command) => client.send(command).catch((err)=>{
            return null;
        }))).then((res) => {

            console.log('all files uploaded success')
        }).catch((error) => {
            console.error('error uploading files:' + error);
        });
    }


    let nSize = 0;
    for (let i=0;i<arrayPutCommands.length;i++){
        const item = arrayPutCommands[i];
        if (item.input.Body instanceof File){
            nSize += item.input.Body.size;
        }else{
            nSize += item.input.Body.length;
        }
    }

    let szUnit = 'kb';
    let size = Math.round(nSize/1024);
    if (size > 1024){
        size = Math.round(size/1024);
        szUnit = 'mb';
    }
    return size + szUnit;
}



/**
 * 设置文件BASE64
 * @param remoteFile
 * @param remoteJsonData
 */
const setFileDataURL =(remoteFile:any,remoteJsonData:any)=>{
    loopAllNode(remoteJsonData.canvas,(item)=>{
        if (item.drawJson?.files){
            if (remoteFile.id in item.drawJson.files){
                item.drawJson.files[remoteFile.id].dataURL = remoteFile.dataURL;
            }
        }
    })
    // for (let i=0;i<remoteJsonData.canvas.length;i++){
    //     const item = remoteJsonData.canvas[i];
    //     if (remoteFile.id in item.drawJson.files){
    //         item.drawJson.files[remoteFile.id].dataURL = remoteFile.dataURL;
    //         break;
    //     }
    // }
}

/**
 * 根据元素ID获取笔记
 * @param notes
 * @param id
 */
const getNoteByElementId = (notes:any,id:string,generationDataId:string)=> {
    for(let i = 0; i < notes.length; i++) {
        const item = notes[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                if (item.children[j].key == id || item.children[j].key == generationDataId){
                    return item.children[j];
                }
            }
        }else{
            if (item.key == id  || item.key == generationDataId){
                return item;
            }
        }
    }
    return null;
}

/**
 * 处理元素上的笔记，组合
 * @param item
 * @param notes
 */
const handleDrawJsonElementNote = (szProjId:any,item:any,notes:any)=>{
    let szS3 = getShareDataUrl() +szProjId+"/notesimage/";
    if ('elements' in item.drawJson){
        for (let i=0;i<item.drawJson.elements.length;i++){
            let element = item.drawJson.elements[i];
            if (isStickyNotesElement(element) || isTextElement(element)){
                if (element.value){
                    element.value = element.value.replaceAll(/src=[\'\"]atom:\/\//g,'src="'+szS3);
                }
            }
            if (element.type == 'iframe'){
                if ("generationData" in element?.customData){
                    const note = getNoteByElementId(notes,element.id,element.customData.generationData.id);
                    if (note){
                        element.customData.generationData.html = note.noteDataDoc;//createNoteElementByNote(note.title,note.noteDataDoc);
                    }
                }
            }
        }
    }
}

/**
 * 处理元素上的mindmap
 * @param item
 * @param notes
 */
const handleDrawJsonElementMindmap = (szProjId:string,item:any)=>{
    if ('elements' in item.drawJson){
        for (let i=0;i<item.drawJson.elements.length;i++){
            let element = item.drawJson.elements[i];
            if (element.type == 'mindmap'){
                const szJsonData = JSON.stringify(element.data).replaceAll("localfile://",getShareDataUrl()+szProjId+"/notesfile/");
                element.data = JSON.parse(szJsonData);
            }
        }
    }
}

/**
 * 处理元素上的视频，组合
 * @param item
 * @param notes
 */
const handleDrawJsonElementVideo = (szProjId:string,item:any)=>{
    const szS3 = getShareDataUrl()+szProjId+"/notesfile/";
    if ('elements' in item.drawJson){
        for (let i=0;i<item.drawJson.elements.length;i++){
            let element = item.drawJson.elements[i];
            if (element.type == 'iframe'){
                if ("generationData" in element?.customData){
                    if (isVideo(element.customData.generationData.fileName)){
                        element.customData.generationData.html = element.customData.generationData.html.replace("localfile://",szS3);
                    }
                }
            }
        }
    }
}

/**
 * 笔记图片的路径换成S3 路径
 * @param notes
 */
const handleNotesImageUrlToS3 = (szProjId:string,notes:any)=>{
    let szS3 = getShareDataUrl() +szProjId+"/notesimage/";
    for (let i=0;i<notes.length;i++){
        let item = notes[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){

            }
        }else{
            if (item.doc && !item.noteDataDoc){
                item.noteDataDoc = item.doc;
            }
            item.noteDataDoc = item.noteDataDoc.replaceAll(/src=[\'\"]atom:\/\//g,'src="'+szS3);
        }
    }
}

//写入笔记到相应的元素
const writeNoteVideoToElement = (szProjId:string,remoteJsonData:any)=>{
    loopAllNode(remoteJsonData.canvas,(item)=>{
        if (item.drawJson){
            handleDrawJsonElementNote(szProjId,item,remoteJsonData.notes);
            //处理视频
            // handleDrawJsonElementVideo(szProjId,item);
            //处理mindmap
            handleDrawJsonElementMindmap(szProjId,item);
        }
    })

    /*
    for (let i=0;i<remoteJsonData.canvas.length;i++){
        let item = remoteJsonData.canvas[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                let subItem = item.children[j];
                handleDrawJsonElementNote(subItem,remoteJsonData.notes);
                //处理视频
                // handleDrawJsonElementVideo(szProjId,subItem)
                //处理mindmap
                handleDrawJsonElementMindmap(szProjId,subItem);
            }
        }else{
            handleDrawJsonElementNote(item,remoteJsonData.notes);
            //处理视频
            // handleDrawJsonElementVideo(szProjId,item);
            //处理mindmap
            handleDrawJsonElementMindmap(szProjId,item);
        }
    }*/
}

/**
 * 获取数据.....
 * @param szProjId
 * @param localJsonData
 */
export async function getS3DataNew(szProjId:string,localJsonData:any,isLazyLoading:boolean = false){

    let client:any;
    if (isAliOss()){
        client = getAliOssClient();
    }else{
        client = getClient();
    }
    let arrayGetCommand:any = [];

    let objStr;
    //1.获取主目录
    let szPublicProj = 'public/'+szProjId+'/'+szProjId;
    if (isAliOss()){
        const result = await client.get(szPublicProj);
        // result.content 是 Buffer（在浏览器中是 ArrayBuffer 或 Uint8Array）
        // 需要转成字符串再解析 JSON
        const decoder = new TextDecoder('utf-8');
        objStr = decoder.decode(result.content);
    }else{
        const command = new GetObjectCommand({
            Bucket:'muenzo-data',
            Key:szPublicProj,
        })
        const { Body } = await client.send(command);
        objStr = await Body.transformToString();
    }


    //step 1
    postMessage(EVENT_UPDATE_PROGRESS,{progress:30});

    //2.获取有更新的数据
    const jsonDataRemote = JSON.parse(objStr);
    loopAllNode(jsonDataRemote.canvas,(item)=>{
        if (item.drawJson?.elements){
            if (hasRemoteUpdate(localJsonData,item,true)){
                const cmd = new GetObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/canvas/'+item.key,
                })
                arrayGetCommand.push(cmd);
            }else{
                item = getItemByKey(localJsonData,item.key,true);
            }
        }
    })

    //note
    for (let i=0;i<jsonDataRemote.notes.length;i++){
        const item = jsonDataRemote.notes[i];
        if (item.isFolder){
            for (let j=0;j<item.children.length;j++){
                const subItem = item.children[j];
                if (subItem.hasUpdate || hasRemoteUpdate(localJsonData,subItem,false)){
                    const cmd = new GetObjectCommand({
                        Bucket:'muenzo-data',
                        Key:'public/'+szProjId+'/notes/'+item.key+'/'+subItem.key,
                    })
                    arrayGetCommand.push(cmd);
                }else{
                    item.children[j] = getItemByKey(localJsonData,subItem.key,false);
                }
            }
        }else{
            if (item.hasUpdate || hasRemoteUpdate(localJsonData,item,false)){
                const cmd = new GetObjectCommand({
                    Bucket:'muenzo-data',
                    Key:'public/'+szProjId+'/notes/'+item.key,
                })
                arrayGetCommand.push(cmd);
            }else{
                jsonDataRemote.notes[i] = getItemByKey(localJsonData,item.key,false);
            }
        }
    }

    console.log('***request*****');
    console.log(arrayGetCommand);
    let nSize = 0;

    if (isAliOss()){
        const res = await Promise.all(arrayGetCommand.map((command:any)=>client.get(command.input.Key,getAliOssObjectFromAws3(command)).catch((err)=>{
            return null;
        })));
        for (let i=0;i<res.length;i++){
            if (res[i] == null)continue;

            const decoder = new TextDecoder('utf-8');
            let szStr = decoder.decode(res[i].content);

            nSize += szStr.length;

            const obj = JSON.parse(szStr);
            //根据ID插入到相应的位置
            setItemToJson(jsonDataRemote,obj,!obj.hasOwnProperty('noteDataDoc'));
        }
    }else{
        const res = await Promise.all(arrayGetCommand.map((command:any)=>client.send(command).catch((err)=>{
            return null;
        })));
        for (let i=0;i<res.length;i++){
            if (res[i] == null)continue;
            const szStr = await res[i].Body.transformToString();
            nSize += szStr.length;

            const obj = JSON.parse(szStr);
            //根据ID插入到相应的位置
            setItemToJson(jsonDataRemote,obj,!obj.hasOwnProperty('noteDataDoc'));
        }
    }


    //step 2***********
    postMessage(EVENT_UPDATE_PROGRESS,{progress:30});

    let arrayGetFileCommand:any = [];
    //这里再来处理一遍本地没有的文件....
    loopAllNode(jsonDataRemote.canvas,(item)=>{
        if (item.drawJson){
            const localItem = getItemByKey(localJsonData,item.key,true);
            setFileDataURLOrCommand(szProjId,"",item,localItem,arrayGetFileCommand,isLazyLoading)
        }
    })

    /*
    for (let i=0;i<jsonDataRemote.canvas.length;i++) {
        const item = jsonDataRemote.canvas[i];
        if (item.isFolder) {
            for (let j=0;j<item.children.length;j++){
                const subItem = item.children[j];
                const localItem = getItemByKey(localJsonData,subItem.key,true);
                setFileDataURLOrCommand(szProjId,item.key+"/",subItem,localItem,arrayGetFileCommand,isLazyLoading)
            }
        }else{
            const localItem = getItemByKey(localJsonData,item.key,true);
            setFileDataURLOrCommand(szProjId,"",item,localItem,arrayGetFileCommand,isLazyLoading)
        }
    }*/

    console.log('***request file*****');
    console.log(arrayGetFileCommand);

    return new Promise((resolve, reject) => {
        if (isAliOss()){
            Promise.all(arrayGetFileCommand.map((command:any)=>client.get(command.input.Key,getAliOssObjectFromAws3(command)).catch((err)=>{
                return null;
            })))
                .then(async (res)=>{
                    let hasErr = false;
                    for (let i=0;i<res.length;i++){
                        if(res[i] == null) {
                            hasErr = true;
                            continue;
                        };

                        const decoder = new TextDecoder('utf-8');
                        let szStr = decoder.decode(res[i].content);

                        nSize += szStr.length;

                        const obj = JSON.parse(szStr);
                        //根据FileId插入到相应的位置
                        setFileDataURL(obj,jsonDataRemote);
                    }
                    if (hasErr){
                        console.log(".....get data has some error.....")
                    }
                    //汇总下，笔记写入相应的元素...
                    handleNotesImageUrlToS3(szProjId,jsonDataRemote.notes);
                    writeNoteVideoToElement(szProjId,jsonDataRemote);

                    //step 3***********
                    postMessage(EVENT_UPDATE_PROGRESS,{progress:100});

                    let szUnit = 'kb';
                    let size = Math.round(nSize/1024);
                    if (size > 1024){
                        size = Math.round(size/1024);
                        szUnit = 'mb';
                    }

                    // setTimeout(()=>{
                    //     message.info('刷新网页成功，产生下行流量:'+size + szUnit);
                    // },1000);
                    if (jsonDataRemote.arrayLibrarys){
                        //写入到库文件
                        for (let i=0;i<jsonDataRemote.arrayLibrarys.length;i++){
                            await updateCard(jsonDataRemote.arrayLibrarys[i]);
                        }
                    }

                    if (jsonDataRemote.arrayWeblinkCache){
                        //写入到缓存表.
                        for (let i=0;i<jsonDataRemote.arrayWeblinkCache.length;i++){
                            await updatecardlinkCache(jsonDataRemote.arrayWeblinkCache[i])
                        }
                    }

                    resolve(jsonDataRemote);
                }).catch(error=>{
                console.log('get data promise error:'+error);
                reject();
            });
        }else{
            Promise.all(arrayGetFileCommand.map((command:any)=>client.send(command).catch((err)=>{
                return null;
            })))
                .then(async (res)=>{
                    let hasErr = false;
                    for (let i=0;i<res.length;i++){
                        if(res[i] == null) {
                            hasErr = true;
                            continue;
                        };

                        const szStr = await res[i].Body.transformToString();
                        nSize += szStr.length;

                        const obj = JSON.parse(szStr);
                        //根据FileId插入到相应的位置
                        setFileDataURL(obj,jsonDataRemote);
                    }
                    if (hasErr){
                        console.log(".....get data has some error.....")
                    }
                    //汇总下，笔记写入相应的元素...
                    handleNotesImageUrlToS3(szProjId,jsonDataRemote.notes);
                    writeNoteVideoToElement(szProjId,jsonDataRemote);

                    //step 3***********
                    postMessage(EVENT_UPDATE_PROGRESS,{progress:100});

                    let szUnit = 'kb';
                    let size = Math.round(nSize/1024);
                    if (size > 1024){
                        size = Math.round(size/1024);
                        szUnit = 'mb';
                    }

                    // setTimeout(()=>{
                    //     message.info('刷新网页成功，产生下行流量:'+size + szUnit);
                    // },1000);
                    let szS3 = getShareDataUrl() +szProjId+"/notesimage/";

                    if (jsonDataRemote.arrayLibrarys){
                        //写入到库文件
                        for (let i=0;i<jsonDataRemote.arrayLibrarys.length;i++){
                            const item = jsonDataRemote.arrayLibrarys[i];
                            if (item.type == 'card'){
                                item.doc = item.doc.replaceAll(/src=[\'\"]atom:\/\//g,'src="'+szS3);
                            }
                            await updateCard(item);
                        }
                    }

                    if (jsonDataRemote.arrayWeblinkCache){
                        //写入到缓存表.
                        for (let i=0;i<jsonDataRemote.arrayWeblinkCache.length;i++){
                            await updatecardlinkCache(jsonDataRemote.arrayWeblinkCache[i])
                        }
                    }

                    resolve(jsonDataRemote);
                }).catch(error=>{
                console.log('get data promise error:'+error);
                reject();
            });
        }

    })

    // try {
    //     const { Body } = await client.send(command);
    //     const objStr = Body.transformToString();
    //     console.log(objStr);
    //     return objStr;
    // }catch (err){
    //     console.log(err);
    // }
}

const getAliOssObjectFromAws3 = (command)=>{
    if (isString(command.input.Body)){
        return jsonToBlob(command.input.Body);
    }
    return command.input.Body
}

/*************publish card******************/
export async function uploadCardS3(szCardId,cardData, arrayFiles){
    const dtNow = Date.now();

    let client:any;
    if (isAliOss()){
        client = getAliOssClient();
    }else{
       client = getClient();
    }
    //first get remote project....
    //1.获取笔记的数据集合目录
    const szNotesImageKey = 'public/'+szCardId+'/notesimage/'
    const arrayImgs:any = [];

    if (isAliOss()){
        const result = await client.list({"max-keys":1000,prefix:szNotesImageKey});
        console.log(result);
        if (result.objects){
            result.objects.forEach(p=>{
                arrayImgs.push(p.name?.replace(szNotesImageKey,''));
            })
        }
    }else{
        let listObjects = new ListObjectsV2Command({
            Bucket:'muenzo-data',
            Prefix: szNotesImageKey,
            MaxKeys: 1000
        })
        const data = await getClient().send(listObjects);
        if (data.Contents){
            data.Contents.forEach(p=>{
                arrayImgs.push(p.Key?.replace(szNotesImageKey,''));
            })
        }
    }

    let arrayPutCommands = [];

    //上传doc
    const commandDoc = new PutObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szCardId+'/data',
        Body:JSON.stringify(cardData)
    })
    arrayPutCommands.push(commandDoc);

    const arrayImages = imgServer.getImageListFromHtml(cardData.doc);
    for (let i=0;i<arrayImages.length;i++){
        const item = arrayImages[i];
        const szName = item.id + '.'+item.ext;
        if (arrayImgs.includes(szName))continue;
        if (!item.data){
            const szFileName = localStorage.getItem(KEY_FILE_DIR) + szName;
            item.data = await ipcInvoke('read-file-base64', {filePath:szFileName})
        }
        //添加到command
        let body = dataURLToFile('data:image/'+ item.ext +';base64,'+item.data,item.id+'.'+item.ext);
        // try{
        //     const blob = await convertImageToWebp('data:image/'+ item.ext +';base64,'+item.data);
        //     body = blobToFile(blob);
        // }catch (e){
        //     console.log('convertImageToWebp...fail')
        // }

        const command = new PutObjectCommand({
            Bucket:'muenzo-data',
            Key:'public/'+szCardId+'/notesimage/'+item.id+"."+item.ext,//path-- public/projId/canvas/文件夹id/文件id
            Body:body
        })
        arrayPutCommands.push(command);
    }

    if (isAliOss()){
        await Promise.all(arrayPutCommands.map((command) => client.put(command.input.Key,getAliOssObjectFromAws3(command)).catch((err)=>{
            return null;
        }))).then((res) => {

            console.log('all files uploaded success')
        }).catch((error) => {
            console.error('error uploading files:' + error);
        });
    }else{
        await Promise.all(arrayPutCommands.map((command) => client.send(command).catch((err)=>{
            return null;
        }))).then((res) => {

            console.log('all files uploaded success')
        }).catch((error) => {
            console.error('error uploading files:' + error);
        });
    }


    return 'ok';
}

export async function getS3CardData(szCardId:any){
    let client:any;
    if (isAliOss()){
        client = getAliOssClient();
    }else{
        client = getClient();
    }
    let arrayGetCommand:any = [];
    //1.获取主目录
    const command = new GetObjectCommand({
        Bucket:'muenzo-data',
        Key:'public/'+szCardId+'/data',
    })
    let szJsonData = '';
    if (isAliOss()){
        const result = await client.get(command.input.Key);
        // result.content 是 Buffer（在浏览器中是 ArrayBuffer 或 Uint8Array）
        // 需要转成字符串再解析 JSON
        const decoder = new TextDecoder('utf-8');
        szJsonData = decoder.decode(result.content);
    }else{
        const { Body } = await client.send(command);
        szJsonData = await Body.transformToString();
    }
    const json = JSON.parse(szJsonData);
    json.doc = handleCardImageUrlToS3(szCardId,json.doc);
    //把里面的图片换掉...
    return JSON.stringify(json);
}

/**
 * 笔记图片的路径换成S3 路径
 * @param notes
 */
const handleCardImageUrlToS3 = (szCardId:string,doc:any)=>{
    let szS3 = getShareDataUrl()+szCardId+"/notesimage/";
    doc = doc.replace(/src=[\'\"]atom:\/\//g,'src="'+szS3);
    return doc;
}

/*************----publish card end----******************/





















